import React, { useState, useContext, useEffect, useRef } from 'react' 
import './RemoteFittingNew.css'
import { ForwardFittingContext } from "./ForwardFittingContext.js"; 
import HeaderAdmin from '../../Components/HeaderAdmin/Header.jsx';
import {  FaPlay } from 'react-icons/fa';
import { FaCheck } from 'react-icons/fa6'; 
import {  Form } from 'react-bootstrap';
import { RiCloseFill } from "react-icons/ri";
import { FaHeart } from "react-icons/fa";
import CameraModal from "../DashboardComponents/ImageUpload/CameraModel.js"  

function RemoteFittingNew() {

    const {   updateremotefitting, updateremotefittingfile, remotefittingimage,   } = useContext(ForwardFittingContext);
  
    
    const [scrollPosition, setScrollPosition] = useState(0);
 

    const [showModal, setShowModal] = useState(false);
    const [isModalOpen, setModalOpen] = useState(null);


    const [iron, setiron] = useState('');
    const [step, setstep] = useState('');
    const [title, settitle] = useState('');
    const [ironeid, setIronId] = useState('');
 
    const handleOpenModal = (color) => {
        setModalOpen(color); // This will set the state to the color passed in as a string
        setScrollPosition(window.scrollY);
    };

    const handleOpenModal2 = (index, step, iron, title) => {
        // setModalOpen(false);
        setActiveIronIndex(index);
        setShowModal(true);
        setiron(iron);
        settitle(title);
        setstep(step);
        setIronId(iron.slice(4)); // after that i have "1"
    };

    const handleCloseModal2 = () => {
        setShowModal(false);
        // setModalOpen(true);
    }

    const handleCloseModal = () => {
        setModalOpen(null)
    };

    const preferredClub = "";

    const updatebutton = (buttonnumber, step) => {
        updateremotefitting(`${step}.preferred_club`, `${buttonnumber}`);
    }

    const [activeIronIndex, setActiveIronIndex] = useState(null);

    const updatePhotoInBox = (imageSrc) => {
        if (activeIronIndex !== null) {
            updateremotefittingfile(step + "." + iron + '.cameraimage', imageSrc);
            // setImageURL(imageSrc);
            handleCloseModal2(); // Close the modal
        }
    };

    const [imageURLstep1iron1, setImageURLStep1Iron1] = useState(null);
    const [imageURLstep1iron2, setImageURLStep1Iron2] = useState(null);
    const [imageURLstep1iron3, setImageURLStep1Iron3] = useState(null);

    const [imageURLstep2iron1, setImageURLStep2Iron1] = useState(null);
    const [imageURLstep2iron2, setImageURLStep2Iron2] = useState(null);
    const [imageURLstep2iron3, setImageURLStep2Iron3] = useState(null);
 
    useEffect(() => {

        const cameraImagestep1iron1 = remotefittingimage?.step1?.iron1?.cameraimage;
        const cameraImagestep1iron2 = remotefittingimage?.step1?.iron2?.cameraimage;
        const cameraImagestep1iron3 = remotefittingimage?.step1?.iron3?.cameraimage;

        const cameraImagestep2iron1 = remotefittingimage?.step2?.iron1?.cameraimage;
        const cameraImagestep2iron2 = remotefittingimage?.step2?.iron2?.cameraimage;
        const cameraImagestep2iron3 = remotefittingimage?.step2?.iron3?.cameraimage;
 

        if (cameraImagestep1iron1 && cameraImagestep1iron1.startsWith("data:image/")) {
            setImageURLStep1Iron1(cameraImagestep1iron1); // Use the base64 image directly
        } else {
            // Reset imageURL if no valid image is found for the current step
            setImageURLStep1Iron1(null);
        }

        if (cameraImagestep1iron2 && cameraImagestep1iron2.startsWith("data:image/")) {
            setImageURLStep1Iron2(cameraImagestep1iron2); // Use the base64 image directly
        } else {
            // Reset imageURL if no valid image is found for the current step
            setImageURLStep1Iron2(null);
        }

        if (cameraImagestep1iron3 && cameraImagestep1iron3.startsWith("data:image/")) {
            setImageURLStep1Iron3(cameraImagestep1iron3); // Use the base64 image directly
        } else {
            // Reset imageURL if no valid image is found for the current step
            setImageURLStep1Iron3(null);
        }

        if (cameraImagestep2iron1 && cameraImagestep2iron1.startsWith("data:image/")) {
            setImageURLStep2Iron1(cameraImagestep2iron1); // Use the base64 image directly
        } else {
            // Reset imageURL if no valid image is found for the current step
            setImageURLStep2Iron1(null);
        }

        if (cameraImagestep2iron2 && cameraImagestep2iron2.startsWith("data:image/")) {
            setImageURLStep2Iron2(cameraImagestep2iron2); // Use the base64 image directly
        } else {
            // Reset imageURL if no valid image is found for the current step
            setImageURLStep2Iron2(null);
        }


        if (cameraImagestep2iron3 && cameraImagestep2iron3.startsWith("data:image/")) {
            setImageURLStep2Iron3(cameraImagestep2iron3); // Use the base64 image directly
        } else {
            // Reset imageURL if no valid image is found for the current step
            setImageURLStep2Iron3(null);
        }
 

    }, [remotefittingimage]);



    return (
        <>
            <div className='remotefittingnewdesign'>
                <div className="main-page-body-content-header" >
                    <HeaderAdmin />
                </div>



                {/* Main Code */}
                <div className="row black_bg_box cf mx-4 " style={{ borderRadius: '40px', backgroundColor: '#1e2025' }}>
                    <div className="club-fitting-card">
                        <div className="gab_title ">
                            <div className="collapsed d-flex">
                                <div className="gab_icon">
                                    <FaCheck />
                                </div>
                                <div className="gab_text ms-3"><h5 className='cf-title'>Iron Test</h5></div>
                            </div>
                        </div>
                        <div className='gab_text' style={{ fontSize: '20px' }}>
                            It’s time to start testing irons. Watch the tutorial below to get an overview of how to go through the fitting process.
                        </div>
                    </div>
                    <div className="col-12 mt-5 w-full">
                        <div eventKey="2" className="mobile-accordion">
                            <div className="bg_green_light" style={{ backgroundColor: '#36454F' }}>
                                <div className="gs_fr_tops" id="lesson_card_1">
                                    <div>
                                        <div className="gab_title">
                                            <div className="gab_text bg-accordion-title">
                                                <h5>How Iron Testing Works</h5>
                                            </div>
                                            <div className="">
                                                <div className="barplay_icon_item">
                                                    <FaPlay size={15} color="#ffffff" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='circle-color d-flex align-items-center justify-content-between mb-2 mt-5'>
                        <div className="gab_text d-flex">
                            <span className="color me-5"></span>
                            <p style={{ fontSize: '24px', fontWeight: '800' }}>White</p>
                        </div>
                        <button
                            className='btn open-btn py-3'
                            style={{ backgroundColor: '#99EA24' }}
                            onClick={() => handleOpenModal('white')} 
                        >
                            Open
                        </button>
                    </div>

                    {isModalOpen === 'white' && (
                        <div className="custom-modal">
                            <div className="modal-content">

                                {/* Scrollable content section */}
                                <div className="scrollable-content">
                                    <div className="main-page-body-content-body">
                                        <div className="main-page-body-content-body-container">
                                            <div className="container-fluid">
                                                <div>
                                                    <div className='back-home d-flex align-items-center justify-content-between mt-3 mb-4'>
                                                        <button className='d-flex align-items-center justify-content-center btn col-12 py-4' onClick={handleCloseModal} style={{ backgroundColor: '#1e2025', color: '#fff' }}>
                                                            <RiCloseFill className='ri-close me-2' size={50} />
                                                            <p>Exit Iron</p>
                                                            <div>Back Home</div>
                                                        </button>
                                                    </div>


                                                    <div className="step-content">
                                                        <div className="step-content-item-2 step-content-item-active  w-100 step-1">
                                                            <div className="step">
                                                                <div className="sec-header-dash white">
                                                                    <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                                                        <h3><span className="color circle-icon"></span> White Irons</h3>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="new-design-border-sec">
                                                        <div className="bg_color_dark">
                                                            <div className="row">
                                                                <div className="col-md-12">
                                                                    <div className="justify-content-center">
                                                                        <div className="">
                                                                            <div className="sec-header-dash border-header-sec white">
                                                                                <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                                                                    <h3 className="box-title-lable">
                                                                                        <span className="color">1</span> White Iron
                                                                                    </h3>
                                                                                </div>
                                                                            </div>
                                                                            <div className="desc">
                                                                                <p>Match up the club faces and upload a photo below with all three shots for us to analyze strike location.</p>
                                                                            </div>
                                                                            <div className="card-video" style={{ width: "100%" }}>
                                                                                <div className="drop-box-camera drop_box drop-box-xyz" onClick={() => handleOpenModal2(0, "step1", "iron1", "White Iron")}>
                                                                                    <input
                                                                                        type="file"
                                                                                        accept=".mp4,.avi,.mkv"
                                                                                        id={`swing1.fileID1`}
                                                                                        style={{ display: 'none' }}
                                                                                    />
                                                                                    {
                                                                                        imageURLstep1iron1 && (
                                                                                            <div className="form">
                                                                                                <img
                                                                                                    className='uploaded-image'
                                                                                                    key={imageURLstep1iron1}
                                                                                                    src={imageURLstep1iron1}
                                                                                                    alt="selectedImage"
                                                                                                    style={{ width: '100%', }}
                                                                                                />
                                                                                            </div>
                                                                                        )
                                                                                    }
                                                                                    <div className='custom-upload-btn'>
                                                                                        <Form.Label className={`btn btn-colr-white add-photo-btn w-100`}>
                                                                                            Add photo
                                                                                        </Form.Label>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="new-design-border-sec">
                                                        <div className="bg_color_dark">
                                                            <div className="row">
                                                                <div className="col-md-12">
                                                                    <div className="justify-content-center">
                                                                        <div className="">
                                                                            <div className="sec-header-dash border-header-sec white">
                                                                                <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                                                                    <h3 className="box-title-lable">
                                                                                        <span className="color">2</span> White Iron
                                                                                    </h3>
                                                                                </div>
                                                                            </div>
                                                                            <div className="desc">
                                                                                <p>Match up the club faces and upload a photo below with all three shots for us to analyze strike location.</p>
                                                                            </div>
                                                                            <div className="card-video" style={{ width: "100%" }}>
                                                                                <div className="drop-box-camera drop_box drop-box-xyz" onClick={() => handleOpenModal2(0, "step1", "iron2", "White Iron")}>
                                                                                    <input
                                                                                        type="file"
                                                                                        accept=".mp4,.avi,.mkv"
                                                                                        id={`swing1.fileID2`}
                                                                                        style={{ display: 'none' }}
                                                                                    />
                                                                                    {
                                                                                        imageURLstep1iron2 && (
                                                                                            <div className="form">
                                                                                                <img
                                                                                                    className='uploaded-image'
                                                                                                    key={imageURLstep1iron2}
                                                                                                    src={imageURLstep1iron2}
                                                                                                    alt="selectedImage"
                                                                                                    style={{ width: '100%' }}
                                                                                                />
                                                                                            </div>
                                                                                        )
                                                                                    }
                                                                                    <div className='custom-upload-btn'>
                                                                                        <Form.Label className={`btn btn-colr-white add-photo-btn w-100`}>
                                                                                            Add photo
                                                                                        </Form.Label>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="new-design-border-sec">
                                                        <div className="bg_color_dark">
                                                            <div className="row">
                                                                <div className="col-md-12">
                                                                    <div className="justify-content-center">
                                                                        <div className="">
                                                                            <div className="sec-header-dash border-header-sec white">
                                                                                <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                                                                    <h3 className="box-title-lable">
                                                                                        <span className="color">3</span> White Iron
                                                                                    </h3>
                                                                                </div>
                                                                            </div>
                                                                            <div className="desc">
                                                                                <p>Match up the club faces and upload a photo below with all three shots for us to analyze strike location.</p>
                                                                            </div>
                                                                            <div className="card-video" style={{ width: "100%" }}>
                                                                                <div className="drop-box-camera drop_box drop-box-xyz" onClick={() => handleOpenModal2(0, "step1", "iron3", "White Iron")}>
                                                                                    <input
                                                                                        type="file"
                                                                                        accept=".mp4,.avi,.mkv"
                                                                                        id={`swing1.fileID3`}
                                                                                        style={{ display: 'none' }}
                                                                                    />
                                                                                    {
                                                                                        imageURLstep1iron3 && (
                                                                                            <div className="form">
                                                                                                <img
                                                                                                    className='uploaded-image'
                                                                                                    key={imageURLstep1iron3}
                                                                                                    src={imageURLstep1iron3}
                                                                                                    alt="selectedImage"
                                                                                                    style={{ width: '100%' }}
                                                                                                />
                                                                                            </div>
                                                                                        )
                                                                                    }
                                                                                    <div className='custom-upload-btn'>
                                                                                        <Form.Label className={`btn btn-colr-white add-photo-btn w-100`}>
                                                                                            Add photo
                                                                                        </Form.Label>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="border-sec">
                                                        <div className="sec-header-dash border-header-sec white">
                                                            <div className="d-flex box-title mb-0" style={{ color: '' }}>
                                                                <div className={`head_check color ${preferredClub ? 'active' : ''}`} style={{ backgroundColor: '#ffffff' }}>
                                                                    <FaHeart style={{ color: '#000000' }} />
                                                                </div>
                                                                <h3 className="box-title-lable">
                                                                    <span className="color-image">
                                                                        {/* SVG content */}
                                                                    </span>
                                                                    Preferred Club
                                                                </h3>
                                                            </div>
                                                            {/* <div className="content-box-btn">
                                                            
                                                        </div> */}
                                                        </div>
                                                        <div className="desc">
                                                            <p>Tell us what club that felt best to you while testing this color by selecting it below. This is 100% preference.</p>
                                                        </div>
                                                        <div className='btn-sec'>
                                                            <div className='btn-list'>
                                                                <button className={`btn-one btn-colr-white `} onClick={() => updatebutton(1, "step1")}>White 1</button>
                                                                <button className={` btn-colr-white `} onClick={() => updatebutton(2, "step1")}>White 2</button>
                                                                <button className={` btn-colr-white`} onClick={() => updatebutton(3, "step1")}>White 3</button>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='d-flex align-items-center justify-content-between mt-3 mb-4 col-12'>
                                                        <button className='btn col-12 py-4' style={{ backgroundColor: '#99EA24' }} onClick={(e) => {
                                                            setModalOpen(false);
                                                        }} >Save Iron</button>
                                                    </div>

                                                    <div className='back-home d-flex align-items-center justify-content-between  mb-4'>
                                                        <button className='d-flex align-items-center justify-content-center btn col-12 py-4' onClick={handleCloseModal} style={{ backgroundColor: '#1e2025', color: '#fff' }}>
                                                            <RiCloseFill className='ri-close me-2' size={50} />
                                                            <p>Exit Iron</p>
                                                            <div>Back Home</div>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    <div className='circle-color d-flex align-items-center justify-content-between mb-2'>
                        <div className="gab_text black_box d-flex align-items-start">
                            <span className="color me-5"></span>
                            <p style={{ fontSize: '24px', fontWeight: '800' }}>Black</p>
                        </div>
                        <button
                            className='btn open-btn py-3'
                            onClick={() => handleOpenModal('black')}
                            style={{
                                backgroundColor: '#99EA24', 
                            }} 
                        >
                            Open
                        </button>
                    </div>


                    {isModalOpen === 'black' && (
                        <div className="custom-modal">
                            <div className="modal-content">

                                {/* Scrollable content section */}
                                <div className="scrollable-content">
                                    <div className="main-page-body-content-body">
                                        <div className="main-page-body-content-body-container">
                                            <div className="container-fluid">
                                                <div>
                                                    <div className='back-home d-flex align-items-center justify-content-between mt-3 mb-4'>
                                                        <button className='d-flex align-items-center justify-content-center btn col-12 py-4' onClick={handleCloseModal} style={{ backgroundColor: '#1e2025', color: '#fff' }}>
                                                            <RiCloseFill className='ri-close me-2' size={50} />
                                                            <p>Exit Iron</p>
                                                            <div>Back Home</div>
                                                        </button>
                                                    </div>


                                                    <div className="step-content">
                                                        <div className="step-content-item-2 step-content-item-active w-100 step-1">
                                                            <div className="step">
                                                                <div className="sec-header-dash white">
                                                                    <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                                                        <h3><span className="color circle-icon" style={{ backgroundColor: '#000000' }}></span> Black Irons</h3>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="new-design-border-sec">
                                                        <div className="bg_color_dark">
                                                            <div className="row">
                                                                <div className="col-md-12">
                                                                    <div className="justify-content-center">
                                                                        <div className="">
                                                                            <div className="sec-header-dash border-header-sec white">
                                                                                <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                                                                    <h3 className="box-title-lable">
                                                                                        <span className="color" style={{ backgroundColor: '#000000', color: '#ffffff' }}>1</span> Black Iron
                                                                                    </h3>
                                                                                </div>
                                                                            </div>
                                                                            <div className="desc">
                                                                                <p>Match up the club faces and upload a photo below with all three shots for us to analyze strike location.</p>
                                                                            </div>
                                                                            <div className="card-video" style={{ width: "100%" }}>
                                                                                <div className="drop-box-camera drop_box drop-box-xyz" onClick={() => handleOpenModal2(0, "step2", "iron1", "Black Iron")}>
                                                                                    <input
                                                                                        type="file"
                                                                                        accept=".mp4,.avi,.mkv"
                                                                                        id={`swing1.fileID`}
                                                                                        style={{ display: 'none' }}
                                                                                    />
                                                                                    {
                                                                                        imageURLstep2iron1 && (
                                                                                            <div className="form">
                                                                                                <img
                                                                                                    className='uploaded-image'
                                                                                                    key={imageURLstep2iron1}
                                                                                                    src={imageURLstep2iron1}
                                                                                                    alt="selectedImage"
                                                                                                    style={{ width: '100%' }}
                                                                                                />
                                                                                            </div>
                                                                                        )
                                                                                    }
                                                                                    <div className='custom-upload-btn'>
                                                                                        <Form.Label className={`btn btn-colr-white add-photo-btn w-100`}>
                                                                                            Add photo
                                                                                        </Form.Label>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="new-design-border-sec">
                                                        <div className="bg_color_dark">
                                                            <div className="row">
                                                                <div className="col-md-12">
                                                                    <div className="justify-content-center">
                                                                        <div className="">
                                                                            <div className="sec-header-dash border-header-sec white">
                                                                                <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                                                                    <h3 className="box-title-lable">
                                                                                        <span className="color" style={{ backgroundColor: '#000000', color: '#ffffff' }}>2</span> Black Iron
                                                                                    </h3>
                                                                                </div>
                                                                            </div>
                                                                            <div className="desc">
                                                                                <p>Match up the club faces and upload a photo below with all three shots for us to analyze strike location.</p>
                                                                            </div>
                                                                            <div className="card-video" style={{ width: "100%" }}>
                                                                                <div className="drop-box-camera drop_box drop-box-xyz" onClick={() => handleOpenModal2(0, "step2", "iron2", "Black Iron")}>
                                                                                    <input
                                                                                        type="file"
                                                                                        accept=".mp4,.avi,.mkv"
                                                                                        id={`swing1.fileID`}
                                                                                        style={{ display: 'none' }}
                                                                                    />
                                                                                    {
                                                                                        imageURLstep2iron2 && (
                                                                                            <div className="form">
                                                                                                <img
                                                                                                    className='uploaded-image'
                                                                                                    key={imageURLstep2iron2}
                                                                                                    src={imageURLstep2iron2}
                                                                                                    alt="selectedImage"
                                                                                                    style={{ width: '100%' }}
                                                                                                />
                                                                                            </div>
                                                                                        )
                                                                                    }
                                                                                    <div className='custom-upload-btn'>
                                                                                        <Form.Label className={`btn btn-colr-white add-photo-btn w-100`}>
                                                                                            Add photo
                                                                                        </Form.Label>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="new-design-border-sec">
                                                        <div className="bg_color_dark">
                                                            <div className="row">
                                                                <div className="col-md-12">
                                                                    <div className="justify-content-center">
                                                                        <div className="">
                                                                            <div className="sec-header-dash border-header-sec white">
                                                                                <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                                                                    <h3 className="box-title-lable">
                                                                                        <span className="color" style={{ backgroundColor: '#000000', color: '#ffffff' }} >3</span> Black Iron
                                                                                    </h3>
                                                                                </div>
                                                                            </div>
                                                                            <div className="desc">
                                                                                <p>Match up the club faces and upload a photo below with all three shots for us to analyze strike location.</p>
                                                                            </div>
                                                                            <div className="card-video" style={{ width: "100%" }}>
                                                                                <div className="drop-box-camera drop_box drop-box-xyz" onClick={() => handleOpenModal2(0, "step2", "iron3", "Black Iron")}>
                                                                                    <input
                                                                                        type="file"
                                                                                        accept=".mp4,.avi,.mkv"
                                                                                        id={`swing1.fileID`}
                                                                                        style={{ display: 'none' }}
                                                                                    />
                                                                                    {
                                                                                        imageURLstep2iron3 && (
                                                                                            <div className="form">
                                                                                                <img
                                                                                                    className='uploaded-image'
                                                                                                    key={imageURLstep2iron3}
                                                                                                    src={imageURLstep2iron3}
                                                                                                    alt="selectedImage"
                                                                                                    style={{ width: '100%' }}
                                                                                                />
                                                                                            </div>
                                                                                        )
                                                                                    }
                                                                                    <div className='custom-upload-btn'>
                                                                                        <Form.Label className={`btn btn-colr-white add-photo-btn w-100`}>
                                                                                            Add photo
                                                                                        </Form.Label>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="border-sec">
                                                        <div className="sec-header-dash border-header-sec white">
                                                            <div className="d-flex box-title mb-0" style={{ color: '' }}>
                                                                <div className={`head_check color ${preferredClub ? 'active' : ''}`} style={{ backgroundColor: '#ffffff' }}>
                                                                    <FaHeart style={{ color: '#000000' }} />
                                                                </div>
                                                                <h3 className="box-title-lable">
                                                                    <span className="color-image">
                                                                        {/* SVG content */}
                                                                    </span>
                                                                    Preferred Club
                                                                </h3>
                                                            </div>
                                                            {/* <div className="content-box-btn">
                                                            
                                                        </div> */}
                                                        </div>
                                                        <div className="desc">
                                                            <p>Tell us what club that felt best to you while testing this color by selecting it below. This is 100% preference.</p>
                                                        </div>
                                                        <div className='btn-sec'>
                                                            <div className='btn-list'>
                                                                <button className={`btn-one btn-colr-white  `} onClick={() => updatebutton(1, "step2")}>Black 1</button>
                                                                <button className={` btn-colr-white  `} onClick={() => updatebutton(2, "step2")}>Black 2</button>
                                                                <button className={` btn-colr-white`} onClick={() => updatebutton(3, "step2")}>Black 3</button>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='d-flex align-items-center justify-content-between mt-3 mb-4 col-12'>
                                                        <button className='btn col-12 py-4' style={{ backgroundColor: '#99EA24' }} onClick={(e) => {
                                                            setModalOpen(false);
                                                        }} >Save Iron</button>
                                                    </div>

                                                    <div className='back-home d-flex align-items-center justify-content-between  mb-4'>
                                                        <button className='d-flex align-items-center justify-content-center btn col-12 py-4' onClick={handleCloseModal} style={{ backgroundColor: '#1e2025', color: '#fff' }}>
                                                            <RiCloseFill className='ri-close me-2' size={50} />
                                                            <p>Exit Iron</p>
                                                            <div>Back Home</div>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
 
                    {/* Camera Modal */}

 


                </div>





            </div>
            <CameraModal
                show={showModal}
                handleClose={handleCloseModal2}
                setPhotoInBox={updatePhotoInBox}
                ironId={ironeid}
                ironTitle={title}
            />
        </>
    )
}

export default RemoteFittingNew